import { colors } from "@material-ui/core";

const white = "#FFFFFF";
const black = "#000000";

// background: {
//   paper: newTheme.palette.background.paper,
//   default: "rgb(245,246,250)",
// },
// text: {
//   primary: "#161616",
//   secondary: "#8B8B8B",
// },
// charts: {
//   bars: "#F7B500",
// },
// primary: {
//   main: "rgb(64,71,72)",
// },
// secondary: {
//   main: "rgb(148,163,165)",
// },

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.blueGrey[900],
    main: colors.blueGrey[700],
    light: colors.blueGrey[100],
  },
  secondary: {
    contrastText: colors.blueGrey[500],
    dark: colors.amber[900],
    main: colors.amber[600],
    light: colors.amber[400],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: "#F4F6F8",
    // darker: "#F0F0F0",
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[300],

  // Custom components:
};

// export default {
//   black,
//   white,
//   primary: {
//     contrastText: white,
//     dark: colors.indigo[900],
//     main: colors.indigo[500],
//     light: colors.indigo[100]
//   },
//   secondary: {
//     contrastText: white,
//     dark: colors.blue[900],
//     main: colors.blue['A400'],
//     light: colors.blue['A400']
//   },
//   success: {
//     contrastText: white,
//     dark: colors.green[900],
//     main: colors.green[600],
//     light: colors.green[400]
//   },
//   info: {
//     contrastText: white,
//     dark: colors.blue[900],
//     main: colors.blue[600],
//     light: colors.blue[400]
//   },
//   warning: {
//     contrastText: white,
//     dark: colors.orange[900],
//     main: colors.orange[600],
//     light: colors.orange[400]
//   },
//   error: {
//     contrastText: white,
//     dark: colors.red[900],
//     main: colors.red[600],
//     light: colors.red[400]
//   },
//   text: {
//     primary: colors.blueGrey[900],
//     secondary: colors.blueGrey[600],
//     link: colors.blue[600]
//   },
//   background: {
//     default: '#F4F6F8',
//     paper: white
//   },
//   icon: colors.blueGrey[600],
//   divider: colors.grey[200],

//   // Custom components:

// };
